import React, { lazy, useEffect, useState } from 'react';
import { createDraft, GetCustomer, getInvoice, updateToPending } from '../../../backend-services';
import {  SidebarDrawer } from '../../common';
import { generateNumber } from '../../../utils';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { ICreateInvoiceData, ICustomer, ItemInput } from '../../../@types';
import { DraftConfirmationPrompt } from '../DraftConfirmationPrompt';
import { createInvoiceData, InvoiceValidationErrors, } from '../../../modules/invoice/invoice';
import { TableColumn } from '../../common/LineItemTable';
import  { InvoiceErrors, validateInvoiceBasicInfo,validateInvoiceItemDetails,validateInvoiceSummary,  } from '../../../modules/validateInvoiceForm';
import PageLoader from '../../common/PageLoader';
import { useCustomerSearch } from '../../../hooks';
import { clearFieldError, handleErrors } from '../../../utils/handleErrors';
import { INVOICE_TABLE_HEADER, PAYMENT_CURRENCY_LIST, REOCCURRING_FREQUENCY } from '../../../constants';
import toast from 'react-hot-toast';
import dayjs from 'dayjs';
import useLineItems from '../../../modules/lineItem';
import StepForm from '../../core/MultiStepForm/StepForm';
import InvoiceBasicInfo from './createTabs/InvoiceBasicInfo';
import InvoiceItemDetails from './createTabs/InvoiceItemDetails';
import InvoiceSummary from './createTabs/InvoiceSummary';
import PlusBoxIcon from '../../../assets/icons/PlusBoxIcon';
import { ImportantCard } from '../../common/TooltipCards/ImportantCard';

// const CreateInventory = lazy(() => import('../../inventory').then(module => ({ default: module.CreateInventory })));

const dropDownCurrency = PAYMENT_CURRENCY_LIST;
const columns: TableColumn[] = INVOICE_TABLE_HEADER;

interface InvoiceFormProps {
  customerId?: string;
  invoiceData: ICreateInvoiceData;
  setInvoiceData: React.Dispatch<React.SetStateAction<ICreateInvoiceData>>;
  headingText: string;
  updatedNewItem?: ItemInput;
}

const InvoiceForm: React.FC<InvoiceFormProps> = (props) => {
  const [formData, setFormData] = React.useState<ICreateInvoiceData>({
    additionalInformation: '',
    customerId: '',
    description: '',
    currency:'',
    discount: 0,
    inventories: [{ id: '', name: '', rate: 0, quantity: 0 }],
    invoiceDueAt:'',
    invoiceNumber: '',
    issueDate: new Date().toISOString().substring(0, 10),
    isReoccurring: false,
    isReoccurringEndDate: '',
    isReoccurringStartDate: '',
    reoccurringGroupName: '',
    status: 'pending',
    tax: 0,
    isPaymentCompleted: false,
    shouldSendEmail:true,
    exchangeRate: 1,
  });
  React.useEffect(() => {
    if (props.invoiceData) {
      setFormData((prevState: any) => ({
        ...prevState,
        additionalInformation: props.invoiceData.additionalInformation,
        customerId: props.invoiceData.customerId,
        customer: props.invoiceData.customerId ? customer : null,
        description: props.invoiceData.description,
        discount: props.invoiceData.discount,
        inventories: props.invoiceData.inventories,
        invoiceDueAt: props.invoiceData.invoiceDueAt,
        invoiceNumber: props.invoiceData.invoiceNumber,
        issueDate: props.invoiceData.issueDate,
        isReoccurring: props.invoiceData.isReoccurring,
        isReoccurringEndDate: props.invoiceData.isReoccurringEndDate,
        isReoccurringStartDate: props.invoiceData.isReoccurringStartDate,
        reoccurringGroupName: props.invoiceData.reoccurringGroupName,
        shippingCharge: props.invoiceData.shippingCharge,
        status: props.invoiceData.status,
        tax: props.invoiceData.tax,
        isPaymentCompleted:props.invoiceData.isPaymentCompleted,
        shouldSendEmail:props.invoiceData.shouldSendEmail,
        currency:props.invoiceData.currency,
         exchangeRate:props.invoiceData.exchangeRate,
      }));
    }
  }, [props.invoiceData]);
  const [validationResults, setValidationResults] = React.useState<InvoiceErrors>({});
  const { invoiceNo } = useParams<{ invoiceNo: string }>();
  const navigate = useNavigate();
  const [customer, setCustomer] = React.useState<ICustomer | null>(null);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [isDraftLoading, setIsisDraftLoading] = React.useState<boolean>(false);
  const [subTotal, setSubtotal] = React.useState<number>(0);
  const [total, setTotal] = React.useState<number>(0);
  const [calcTax, setCalcTax] = React.useState(0);
  const [calcDiscount, setCalcDiscount] = React.useState(0);
  const [showSidebar, setShowSidebar] = React.useState(false);
  const [showSuccessModal, setShowSuccessModal] = React.useState(false);
  const [isReoccurringChecked, setIsReoccurringChecked] = React.useState(false);
  const [showCreateSidebar, setShowCreateSidebar] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState('');
  const [createdInvoiceId, setCreatedInvoiceId] = React.useState('');
  const [createdEmail, setCreatedEmail] = React.useState('');
  const [activeStep, setActiveStep] = useState(0);
  const totalSteps = 2;
  const [currentTab, setCurrentTab] = useState(0);
  const [step1Validated, setStep1Validated] = useState(false); 
  const [showRateInput, setShowRateInput] = useState(false);
  const [markAsPaid, setMarkAsPaid] = React.useState(false);
  const [sendEmail, setSendEmail] = React.useState(false);
  const [shouldSendWhatsApp, setShouldSendWhatsApp]= React.useState(false);
const [currencyRate, setCurrencyRate] = useState('');
const [selectedCurrencyLabel, setSelectedCurrencyLabel] = React.useState('');



  const [draftValidationResults, setDraftValidationResults] = React.useState<InvoiceValidationErrors>({
    customerId: undefined,
    invoiceNumber: undefined,
    invoiceDueAt: '',
    description: undefined,
    status: undefined,
    issueDate: undefined,
    additionalInformation: undefined,
    shippingCharge: undefined,
    discount: undefined,
    tax: undefined,
    isReoccurring: undefined,
    isReoccurringStartDate: undefined,
    isReoccurringEndDate: undefined,
    reoccurringGroupName: undefined,
    task: undefined,
    inventories: undefined,
    currency: undefined,
    exchangeRate: undefined,
  });

  const { items, addItem, removeItem, updateCell, updateRow } = useLineItems([
    { id: '', name: '', rate: 0, quantity: 0 },
  ]);

  React.useEffect(() => {
    const autoGenerateNo = () => {
      const generate = generateNumber();
      setFormData((prevFormData) => ({
        ...prevFormData,
        invoiceNumber: generate,
      }));
    };

    autoGenerateNo();
  }, []);

  React.useEffect(() => {
    clearFieldError('inventories', validationResults, setValidationResults);
    setFormData((prevState: ICreateInvoiceData) => {
      return {
        ...prevState,
        inventories: items,
      };
    });
  }, [items]);

  // Handler for input changes
  const handleInputChange = (event: { target: { name: any; value: any } }) => {
    const { name, value } = event.target;
    setFormData((prevData) => {
      return { ...prevData, [name]: value };
    });
    clearFieldError(name, validationResults, setValidationResults);
  };

  useEffect(() => {
    let subTotal = 0;
    for (const inventory of formData.inventories) {
      subTotal += inventory.quantity * inventory.rate;
    }
    let discountAmount = subTotal * (formData.discount ? formData.discount / 100 : 0);
    let taxAmount = subTotal * (formData.tax ? formData.tax / 100 : 0);
    let total = subTotal - discountAmount + taxAmount;
    setSubtotal(subTotal);
    setTotal(total);
    setCalcTax(taxAmount);
    setCalcDiscount(discountAmount);
    setFormData((prevData) => {
      return { ...prevData, total: total.toFixed(2).toString() };
    });
  }, [formData.inventories, formData.discount, formData.tax]);
  const handleCreateInventory = (inventory: any) => {
    addItem();
    updateRow(items.length - 1, inventory);
  };



  const handleDropDownChange = (name: string, value: string) => {
    clearFieldError(name, validationResults, setValidationResults);
    const selectedLabel = PAYMENT_CURRENCY_LIST.find((currency) => currency.value === value)?.label || '';
  
    setFormData({ ...formData, [name]: value });
    setSelectedCurrencyLabel(selectedLabel); 
    setShowRateInput(value !== 'NGN');
  };
  
  
  

  const location = useLocation();
  const { customerId } = useParams();
  React.useEffect(() => {
    if (customerId) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        name: decodeURIComponent(customerId || ''),
      }));
    }
  }, [customerId]);

  const handleSetCustomer = (selectedCustomer: ICustomer | null) => {
    if (selectedCustomer) {
      setCustomer(selectedCustomer);
      if (selectedCustomer.id) {
        setFormData((prevFormData: any) => ({
          ...prevFormData,
          customerId: selectedCustomer.id,
          name: `${selectedCustomer.firstName} ${selectedCustomer.lastName}`,
        }));
      }
    } else {
      setCustomer(null);
      setFormData((prevFormData: any) => ({
        ...prevFormData,
        customerId: '',
        name: '',
      }));
    }
  };

  const { data: customers, isSearching, handleSearch: handleCustomerSearch } = useCustomerSearch();
  const handleNextTab = () => {
    let isValid = true;
  
    // Validate based on the current tab
    if (currentTab === 0) {
      isValid = validateInvoiceBasicInfo(formData, setValidationResults);
    } else if (currentTab === 1) {
      isValid = validateInvoiceItemDetails(formData, setValidationResults);
    } else if (currentTab === 2) {
      isValid = validateInvoiceSummary(formData, setValidationResults);
    }
  
    if (isValid) {
      setCurrentTab(currentTab + 1);
    }
  };
  const handlePreviousTab = () => {
    if (currentTab > 0) {
      setCurrentTab(currentTab - 1);
    }
  };
 

  useEffect(() => {
    if (
      typeof formData.exchangeRate !== 'number' &&
      isNaN(Number(formData.exchangeRate))
    ) {
      // Set the exchange rate to 1
      setFormData((prevData) => ({
        ...prevData,
        exchangeRate: 1,
      }));
    }
  }, [formData.exchangeRate]);
  

  const processCreateInvoice = async (sendEmail: boolean, markedAsPaid: boolean, shouldSendWhatsApp: boolean,) => {
    try {
      setIsLoading(true);
      setShowCreateSidebar(false);
  
      const { invoiceDueAt, issueDate, inventories, discount, tax, customerId, isReoccurring } = formData;
      const invoiceData: ICreateInvoiceData = {
        customerId: customerId,
        shouldSendEmail: sendEmail,
        isPaymentCompleted: markedAsPaid,
        shouldSendWhatsApp: shouldSendWhatsApp,
        isReoccurring: isReoccurring,
        invoiceDueAt: new Date(invoiceDueAt || '').toISOString(),
        issueDate: new Date(issueDate || '').toISOString(),
        inventories: inventories.length
          ? inventories.map((i: { id: ''; name: ''; rate: ''; quantity: '' }) => ({
              id: i.id,
              name: i.name,
              rate: Number(i.rate),
              quantity: Number(i.quantity),
            }))
          : [],
        discount: Number(discount ? discount  : 0),
        tax: Number(tax ? tax  : 0),
        isReoccurringEndDate: formData.isReoccurringEndDate || '',
        reoccurringGroupName: formData.reoccurringGroupName || '',
        status: formData.status || 'pending',
        description: formData.description || '',
        additionalInformation: formData.additionalInformation || '',
        currency: formData.currency || '',
        exchangeRate: formData.exchangeRate,
      };
 
      if (customer) {
        if (invoiceNo) {
          const taxValue = formData.tax ? Number(formData.tax) / 100 : 0;
          const formattedTax = taxValue.toFixed(2);
          const updatedInvoiceData: {
            status: string;
            invoiceDueAt: string;
            issueDate: string;
            inventories: {
              id: string;
              name: string;
              rate: number;
              quantity: number;
            }[];
            discount: number;
            tax: number;
          } = {
            status: 'pending',
            invoiceDueAt: new Date(formData.invoiceDueAt || '').toISOString(),
            issueDate: new Date(formData.issueDate || '').toISOString(),
            inventories: formData.inventories.length
              ? formData.inventories.map((i: { id: ''; name: ''; rate: ''; quantity: '' }) => ({
                  id: i.id,
                  name: i.name,
                  rate: Number(i.rate),
                  quantity: Number(i.quantity),
                }))
              : [],
            discount: Number(formData.discount ? formData.discount / 100 : 0),
            tax: Number(formattedTax),
          };
  
          const createdUpdatedInvoice = await updateToPending({ id: invoiceNo, data: updatedInvoiceData });
          const createdInvoiceId = createdUpdatedInvoice?.id;
          const createdEmail = customer.email || ''; 
  
          setCreatedInvoiceId(createdInvoiceId);
          setCreatedEmail(createdEmail);
          setShowSuccessModal(true);
        } else {
          const createdInvoice = await createInvoiceData(invoiceData, customer);
          const createdInvoiceId = createdInvoice?.id;
          const createdEmail = customer.email || '';
  
          setCreatedInvoiceId(createdInvoiceId);
          setCreatedEmail(createdEmail);
         
        navigate(`/invoices/notification/${createdInvoiceId}`);
        }
      } else {
        console.log('Customer is null or undefined');
      }
    } catch (error) {
      handleErrors(error, setErrorMessage);
      setIsLoading(false);
      console.log('Error:', error);
    }
  };
  

  const onCreateInvoice = async (event: any) => {
    event.preventDefault();

    const isValidated = validateCurrentStep();
  
    if (isValidated) {
    
      if (formData.isReoccurring) {
  
        const isSummaryValidated = validateInvoiceSummary(formData, setValidationResults);
  
        if (isSummaryValidated) {
    
          await processCreateInvoice(sendEmail, markAsPaid, shouldSendWhatsApp);

        }
      } else {
        await processCreateInvoice(sendEmail, markAsPaid, shouldSendWhatsApp);

      }
    }
  };
  function handleSendEmailChange(event: { target: { checked: boolean | ((prevState: boolean) => boolean) } }) {
    setSendEmail(event.target.checked);
  }
  function handleMarkAsPaidChange(event: { target: { checked: boolean | ((prevState: boolean) => boolean) } }) {
    setMarkAsPaid(event.target.checked);
  }
  function handleshouldSendWhatsAppChange(event: { target: { checked: boolean | ((prevState: boolean) => boolean); }; }) {
    setShouldSendWhatsApp(event.target.checked);
  }
  const onSaveDraft = async (event: any) => {
    event.preventDefault();
  
    const isValidated = validateCurrentStep();
  
    if (isValidated) {
      setShowSidebar(true);
    }
  };
  


  const processCreateDraftIInvoice = async (e?: any) => {
    setIsisDraftLoading(true);
    setShowSidebar(false);
    const invoiceData: ICreateInvoiceData = {
      customerId: customer?.id,
      description: formData.description,
      invoiceDueAt: formData?.invoiceDueAt ? new Date(formData?.invoiceDueAt)?.toISOString() : undefined,
      issueDate: formData?.issueDate ? new Date(formData?.issueDate)?.toISOString() : undefined,
      additionalInformation: formData.additionalInformation,
      discount: Number(formData.discount ? formData.discount / 100 : 0),
      tax: Number(formData.tax ? formData.tax / 100 : 0),
      isReoccurring: formData.isReoccurring,
      status: 'draft',
      currency: formData.currency,
       exchangeRate: formData.exchangeRate,
      inventories: formData.inventories.length
        ? formData.inventories.map((i: { id: ''; name: ''; rate: ''; quantity: '' }) => ({
            id: i.id,
            name: i.name,
            rate: Number(i.rate),
            quantity: Number(i.quantity),
          }))
        : undefined,
      ...(formData.isReoccurring && {
        reoccurringGroupName: formData.reoccurringGroupName,
        isReoccurringStartDate: new Date().toISOString(),
        isReoccurringEndDate: new Date(formData.isReoccurringEndDate || '').toISOString(),
      }),
    };
    try {
      const response = await createDraft(invoiceData);
      setIsisDraftLoading(false);
      navigate('/invoices');
      toast.success('Draft saved successfully!');
    } catch (error) {
      handleErrors(error, setErrorMessage);
      setIsisDraftLoading(false);
      const errorEl = document.getElementById('error-message');
      errorEl?.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
      document.getElementById('top-of-page')?.scrollIntoView({ behavior: 'smooth' });
      setIsLoading(false);
      setErrorMessage('An error occurred.');
    }
  };
  const customerIdFromURL = new URLSearchParams(window.location.search).get('customerId');

  React.useEffect(() => {
    const fetchCustomerData = async () => {
      try {
        if (customerIdFromURL) {
          const customerResponse = await GetCustomer(customerIdFromURL);
          if (customerResponse.id) {
            const customerData = {
              name: `${customerResponse.firstName} ${customerResponse.lastName}`,
              id: customerResponse.id,
              firstName: customerResponse.firstName,
              lastName: customerResponse.lastName,
              email: customerResponse.email,
              phone: customerResponse.phone,
              address: customerResponse.address,
              city: customerResponse.city,
              state: customerResponse.state,
            };
            setCustomer(customerData);

            setFormData((prevState) => ({
              ...prevState,
              customerId: customerData.id,
            }));
          }
        }
      } catch (error) {
        // Handle error case
      }
    };

    fetchCustomerData();
  }, [customerIdFromURL]);

  React.useEffect(() => {
    const fetchInvoiceData = async () => {
      try {
        if (invoiceNo) {
          const response = await getInvoice(invoiceNo);
          if (response.inventories) {
            const inventoryIds = response.inventories.map((item: { id: any }) => item.id);
            setFormData((prevState) => ({
              ...prevState,
              customerId: response.customerId,
              invoiceNumber: response.invoiceNumber,
              discount: response.discount ? response.discount * 100 : 0,
              tax: response.tax ? response.tax * 100 : 0,
              invoiceDueAt: dayjs(response.invoiceDueAt).format('YYYY-MM-DD'),
              inventories: response.inventories.map(
                (item: { name: string; id: string; quantity: number; rate: number }) => ({
                  name: item.name,
                  id: item.id,
                  quantity: item.quantity,
                  rate: item.rate,
                }),
              ),
              additionalInformation: response.additionalInformation,
              description: response.description,
              currency: response.currency,
              exchangeRate: response.exchangeRate,
            }));
            setCalcTax(response.tax);
            setCalcDiscount(response.discount);

            // Populate form data with customer name from URL parameter
            const urlParams = new URLSearchParams(window.location.search);
            const customerName = urlParams.get('customerName');
            if (customerName) {
              setFormData((prevState) => ({
                ...prevState,
                name: customerName,
              }));
            }

            // Fetch customer data based on customerId
            const customerResponse = await GetCustomer(response.customerId);
            if (customerResponse.id) {
              const customerData = {
                name: `${customerResponse.firstName} ${customerResponse.lastName}`,
                id: customerResponse.id,
                firstName: customerResponse.firstName,
                lastName: customerResponse.lastName,
                email: customerResponse.email,
                phone: customerResponse.phone,
                address: customerResponse.address,
                city: customerResponse.city,
                state: customerResponse.state,
              };
              setCustomer(customerData);
            }
          } else {
          }
        }
      } catch (error) {}
    };

    fetchInvoiceData();
  }, [invoiceNo]);
  if (validationResults.customerId) {
    const errorEl = document.getElementById('theError-message');
    errorEl?.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    document.getElementById('top-of-page')?.scrollIntoView({ behavior: 'smooth' });
  }

  if (validationResults.invoiceDueAt) {
    const errorEl = document.getElementById('theError-message');
    errorEl?.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    document.getElementById('top-of-page')?.scrollIntoView({ behavior: 'smooth' });
  }

  if (validationResults.issueDate) {
    const errorEl = document.getElementById('theError-message');
    errorEl?.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    document.getElementById('top-of-page')?.scrollIntoView({ behavior: 'smooth' });
  }

  const handleIsReoccurringChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const target = e.target as HTMLInputElement;
    setFormData((prevData) => ({
      ...prevData,
      isReoccurring: target.checked,
    }));
    setIsReoccurringChecked(target.checked);
  };

  if (validationResults.customerId) {
    const errorEl = document.getElementById('error-message');
    errorEl?.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    document.getElementById('top-of-page')?.scrollIntoView({ behavior: 'smooth' });
  }
  const validateCurrentStep = (): boolean => {
    const validationFunctionMap = [
      validateInvoiceBasicInfo,
      validateInvoiceItemDetails,
      validateInvoiceSummary,
    ];
  
    const currentValidationFunction = validationFunctionMap[activeStep];
  
    if (currentValidationFunction) {
      const isValid = currentValidationFunction(formData, setValidationResults);
      return isValid;
    }
  
    return true;
  };
  
  const stepInformation = [
    {
      title: "To add a new customer, Click",
      subTitle: "New Customer",
      icon: <PlusBoxIcon />,
      spanText1: " to get started",
      spanText2: "If it’s an existing customer",
      spanText3: 'Enter the first three letters',
      spanText4: 'of the customer’s name',
      spanText5: 'to select the customer',
    },
    {
      title: "To add a new product, Click",
      subTitle: "New Inventory",
      icon: <PlusBoxIcon />,
      spanText1: " to get started",
      spanText2: " If it’s an existing product",
      spanText3: 'Enter the first two letters',
      spanText4: 'of the product’s name',
      spanText5: 'to select the product',
    },
    {
      spanText2: "If the invoice is recurring, Click on the toggle button and fill in the dates. If not, Click on",
      spanText3: 'Create Invoice',
      spanText4: 'to get submit the form',
   
    },
  ];
  

  return (
    <>
      {isLoading && <PageLoader />}
      <div>
        <div className="flex items-left gap-[8.5px] ml-[em]">
          <a href="/invoices">
            <svg
              className="mt-[-2px] ml-[-2em] "
              width="10"
              height="16"
              viewBox="0 0 10 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M8.5 1L1.5 8L8.5 15" stroke="#33363F" strokeWidth="2" />
            </svg>
          </a>
          <h1 className="flex items-center xl:text-[20px] text-[16px] ml-[-1em] mt-[-0.4em] xl:mt-[-0.4em] font-semibold">Add New Invoice</h1>
        </div>
        <div className=" hidden lg:block md:block flex justify-start  4xl:px-[9em]  3xl:px-[7em] 2xl:px-[6em] xl:px-[5em] biglg:px-[5em] lg:px-[4em] biglg:mt-[40px] xl:mt-[40px] lg:mt-[40px]  md:mt-[40px] ">
        <ImportantCard
  title={stepInformation[currentTab]?.title ?? ""}
  subTitle={stepInformation[currentTab]?.subTitle ?? ""}
  icon={stepInformation[currentTab]?.icon ? <PlusBoxIcon /> : undefined}
  spanText1={stepInformation[currentTab]?.spanText1 ?? ""}
  spanText2={stepInformation[currentTab]?.spanText2 ?? ""}
  spanText3={stepInformation[currentTab]?.spanText3 ?? ""}
  spanText4={stepInformation[currentTab]?.spanText4 ?? ""}
  spanText5={stepInformation[currentTab]?.spanText5 ?? ""}
/>

      </div>
        <StepForm
          stepTitles={['Basic Info', 'Item Details', 'Total Payment']}
          nextButtonHandler={handleNextTab}
          backButtonHandler={handlePreviousTab}
          cancelButtonHandler={() => console.log('Cancel')}
          commonButtonText="Create Invoice"
          formData={formData}
          onCreateInvoice={onCreateInvoice}
          onSaveDraft={onSaveDraft}
          step1Validated={ step1Validated}
          handleSetCustomer={handleSetCustomer}
          validationResults={validationResults}
          setValidationResults={setValidationResults}
          isLoading={isLoading}
          isDraftLoading={isDraftLoading}
        >
          <InvoiceBasicInfo
            handleInputChange={handleInputChange}
            validationResults={validationResults}
            formData={formData}
            setFormData={setFormData}
            handleDropDownChange={handleDropDownChange}
            setValidationResults={setValidationResults}
            handleSetCustomer={handleSetCustomer}
              validateCurrentStep={validateCurrentStep}
              invoiceNo={invoiceNo}
              showRateInput={showRateInput}
              customer={customer}
              selectedCurrencyLabel={selectedCurrencyLabel} 
          />
          <InvoiceItemDetails 
          formData={formData} 
          setFormData={setFormData} 
          invoiceNo={invoiceNo}
          validationResults={validationResults}
          setValidationResults={setValidationResults}
          />

          <InvoiceSummary
            subTotal={subTotal}
            formData={formData}
            handleInputChange={handleInputChange}
            calcDiscount={calcDiscount}
            calcTax={calcTax}
            total={total}
            handleDropDownChange={handleDropDownChange}
            handleIsReoccurringChange={handleIsReoccurringChange}
            validationResults={validationResults}
            invoiceNo={invoiceNo}
            sendEmail={sendEmail}
            markAsPaid={markAsPaid} 
            shouldSendWhatsApp={shouldSendWhatsApp}
            handleMarkAsPaidChange={handleMarkAsPaidChange}
            handleSendEmailChange={handleSendEmailChange}
            handleshouldSendWhatsAppChange={handleshouldSendWhatsAppChange}
                  />
        </StepForm>


        {showSidebar && (
          <SidebarDrawer title="Save as Draft" show={true} onClose={() => setShowSidebar(false)} position={'left'}>
            <DraftConfirmationPrompt
              onSaveDraft={processCreateDraftIInvoice}
              onClose={() => setShowSidebar(false)}
              showSidebar={showSidebar}
            />
          </SidebarDrawer>
        )}
      </div>
    </>
  );
};
export { InvoiceForm };